import { render, staticRenderFns } from "./BoxLoader.vue?vue&type=template&id=05905a51&"
import script from "./BoxLoader.vue?vue&type=script&setup=true&lang=js&"
export * from "./BoxLoader.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./BoxLoader.vue?vue&type=style&index=0&id=05905a51&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports